{
  "title": "Уведомления",
  "empty": {
    "title": "Ближайших событий нет",
    "hint": "Дни рождения, скорые отпуска и праздники появятся здесь."
  },
  "when": {
    "today": "Сегодня",
    "tomorrow": "Завтра",
    "inDays": "Через {{count}} дн."
  },
  "events": {
    "birthday": "{{name}} исполняется {{turns}}",
    "timeOffStart": "{{name}} — начинается {{type}} (до {{end}})",
    "timeOffEnd": "{{name}} возвращается на работу",
    "holiday": "Праздник: {{name}}"
  },
  "dropdownHint": "Ближайшие 14 дней"
}
